import FeatureCardContent, { FeatureCardContentProps } from "@components/FeatureCardV2/FeatureCardContent";
import React from "react";
import FeatureCardMedia, { FeatureCardMediaProps } from "./FeatureCardMedia";

export interface FeatureCardMediaPositionProps {
    mediaPosition: "left" | "right";
}

export interface FeatureCardItemProps extends FeatureCardContentProps, FeatureCardMediaProps, FeatureCardMediaPositionProps {}

interface FeatureCardProps {
    cardData: FeatureCardItemProps[];
    isArabic?: boolean;
    mobileView?: "content-first" | "image-first";
    version?: "v2";
    chipTitleVersion?: "v2";
    mediaStyle?: React.CSSProperties;
    addDivider?: boolean;
}

const FeatureCard: React.FC<FeatureCardProps> = (props) => {
    const { cardData, mobileView = "image-first", isArabic, version, chipTitleVersion, mediaStyle, addDivider } = props;
    const isV2 = version === "v2";
    return (
        <div className={`${isV2 ? "lg:max-w-7xl" : "lg:max-w-6xl"} lg:mx-auto w-full`}>
            {cardData.map((inputContent, index) => {
                return (
                    <div
                        key={index}
                        className={`${isV2 ? "lg:max-w-7xl" : "lg:max-w-6xl"} lg:mx-auto w-full flex lg:flex-row ${addDivider ? "py-10 lg:py-20" : "lg:pb-0 pb-10 mt-20"}  ${
                            mobileView === "content-first"
                                ? inputContent.mediaPosition === "left"
                                    ? "flex-col-reverse"
                                    : "flex-col"
                                : inputContent.mediaPosition === "left"
                                ? "flex-col"
                                : "flex-col-reverse"
                        } lg:items-center lg:gap-6 gap-10`}
                        style={{ borderBottom: addDivider ? "1px solid #E2E8F0" : "none" }}
                    >
                        {inputContent.mediaPosition === "left" && (
                            <>
                                <FeatureCardMedia {...inputContent} mediaStyle={mediaStyle} />
                                <FeatureCardContent {...inputContent} isArabic={isArabic} version={version} chipTitleVersion={chipTitleVersion} />
                            </>
                        )}
                        {inputContent.mediaPosition === "right" && (
                            <>
                                <FeatureCardContent {...inputContent} isArabic={isArabic} version={version} chipTitleVersion={chipTitleVersion} />
                                <FeatureCardMedia {...inputContent} mediaStyle={mediaStyle} />
                            </>
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default FeatureCard;
